import type { PageEntityMap } from './helpers/pulsePage';

export type PageData = {
  [K in keyof PageEntityMap]: {
    pageType: K;
    entity: PageEntityMap[K];
  };
}[keyof PageEntityMap];

let pageData: PageData | undefined;

export const setCurrentPageData = (newPageData: PageData) => {
  pageData = newPageData;
};

export const getCurrentPageData = () => pageData;
